export const adminActionTypes = {
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',

  LOGOUT_REQUEST: 'LOGOUT_REQUEST',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
  LOGOUT_FAILURE: 'LOGOUT_FAILURE',

  UPDATE_PROFILE_REQUEST: 'UPDATE_PROFILE_REQUEST',
  UPDATE_PROFILE_SUCCESS: 'UPDATE_PROFILE_SUCCESS',
  UPDATE_PROFILE_FAILURE: 'UPDATE_PROFILE_FAILURE',
}

export const adminActions = {
  login: (payload, callback) =>
  ({
    type: adminActionTypes.LOGIN_REQUEST,
    payload,
    callback
  }),
  logout: (payload, callback) =>
  ({
    type: adminActionTypes.LOGOUT_REQUEST,
    payload,
    callback
  }),
  updateProfile: (payload, callback) =>
  ({
    type: adminActionTypes.UPDATE_PROFILE_REQUEST,
    payload,
    callback
  }),
};

export default adminActions;